import React, { useContext, useEffect, useState } from "react";
import {
  ManageTransactionLayout,
  SearchDropdownWithAPI,
  SearchableList,
  FieldDropSide,
  WithDrawalApprovalCard,
  RolloverinApprovalCard,
  Link,
  LoaderWrapper,
} from "../../../components";
import { Formik, Field } from "formik";

import { Button, Form, Row, Col, Toast } from "react-bootstrap";
import {
  FLOW_TYPES,
  formFields,
  getAdvancedPathWithParam,
  getPathWithParam,
  manageTransactionFormNames,
  MANAGE_TRANSACTION_ROUTES,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  optionsinFilter,
  transactionFormFields,
  RECORDS_TO_FETCH,
  MANAGE_CENSUS_ROUTES,
  getParamsFromQueryString,
} from "../../../utils";
// import { ROUTES, MANAGE_TRANSACTION_ROUTES, ApplicationRoute } from "../utils";
import {
  appLayoutStore,
  manageTransactionStore,
  setManageTransactionToastInfo,
} from "../../../contexts";
import {
  getApprovalRolloverinEmployee,
  getApprovalWithdrawalEmployee,
  getDraftRolloverinEmployee,
  getWithDrawalApprovalSearchinEmployee,
} from "../../../services";
import authService from "../../../components/api-authorization/AuthorizeService";
import { useDeepEffect, useRequest } from "../../../abstracts";
import TransactionFilterCard from "../TransactionFilterCard";
import InfiniteScroll from "react-infinite-scroller";
import { get } from "lodash";

const PendingRolloverin = (props) => {
  const { state, dispatch } = useContext(manageTransactionStore);
  const { state: state2, dispatch: dispatch2 } = useContext(appLayoutStore);
  const { history } = props;
  const formName = manageTransactionFormNames.MANAGE_WITHDRWAL;
  const fields = formFields[formName];
  const [roleName, setRoleName] = useState("");
  const [rolloverinListEmployee, setRolloverinListEmployee] = useState([]);
  const [employeeRolloverin, setEmployeeRolloverin] = useState([]);
  const [employeeName, setEmployeeName] = useState();
  const [toast, setToast] = useState(getParamsFromQueryString("saveSuccess"));
  const [apiRequest, setApiRequest] = useState({
    companyId: 0,
    planId: 0,
    requestedDateFrom: null,
    requestedDateTo: null,
    employeeNameOrSSNSearch: "",
    isAscendingByRequestedDate: true,
    from: 0,
    offset: RECORDS_TO_FETCH,
  });
  const [append, setAppend] = useState(false);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoad, setDataLoad] = useState(false);
  const onBackClick = () => {
    const { history } = props;
    history.push(
      getPathWithParam({
        path: MANAGE_TRANSACTION_ROUTES.APPROVAL,
      })
    );
    // dispatch(
    //   setManageTransactionToastInfo({
    //     showToast: true,
    //     toastMessage: "Withdrawal request is rejected",
    //     toastMessage1: "Employee Name|Reason ",
    //     reject: true,
    //   })
    // );
  };
  // useEffect(() => {
  //   getRole().then((res) => setRoleName(res));
  // }, []);
  // const getRole = async () => {
  //   return await authService.getRole();
  // };
  const buttons = [
    {
      label: "Back",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      onClick: onBackClick,
    },
  ];

  useDeepEffect(() => {
    if (!append) {
      setDataLoad(true);
    }
    setIsLoading(true);
    getApprovalRolloverinEmployee(apiRequest)
      .then((response) => {
        setDataLoad(false);
        setTotalEmployees(response.count);
        if (
          response?.rolloverInRequestDetailsReadyForApproval?.length <
          RECORDS_TO_FETCH
        )
          setStopInfiniteScroll(true);
        if (append)
          setRolloverinListEmployee((rolloverinListEmployee) => {
            return [
              ...rolloverinListEmployee,
              ...response?.rolloverInRequestDetailsReadyForApproval,
            ];
          });
        else
          setRolloverinListEmployee(
            response?.rolloverInRequestDetailsReadyForApproval
          );
        setIsLoading(false);
        // dispatch(
        //   setManagePageLevelData({
        //     formName: formName,
        //     fieldData: request,
        //   })
        // );
      })
      .catch((error) => {
        // Handle Errors
        setIsLoading(false);
      });
  }, [apiRequest]);

  return (
    <ManageTransactionLayout
      layoutHeader="Rolloverin requests Pending Approval"
      buttons={buttons}
      pageFlow={FLOW_TYPES.ADD}
    >
      <TransactionFilterCard
        fields={fields}
        append={append}
        setAppend={setAppend}
        apiRequest={apiRequest}
        setApiRequest={setApiRequest}
        setRolloverinListEmployee={setRolloverinListEmployee}
      />

      <div className="d-flex flex-row justify-content-end text-right records-text ft-14 mr-3">
        {totalEmployees} request(s)
      </div>

      <div style={{ height: "59%", overflow: "scroll" }}>
        <LoaderWrapper isLoading={dataLoad}>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              setAppend(true);
              setApiRequest((apiRequest) => {
                return {
                  ...apiRequest,
                  from: rolloverinListEmployee?.length,
                };
              });
            }}
            hasMore={!stopInfiniteScroll}
            initialLoad={false}
            threshold={100}
            useWindow={false}
            loader={
              rolloverinListEmployee.length != 0 && (
                <div className="loader" key={0}>
                  Loading ...
                </div>
              )
            }
          >
            {rolloverinListEmployee?.map((ti) => {
              return (
                <div
                  style={{
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  <RolloverinApprovalCard
                    employeeRolloverin={ti}
                    title={ti}
                    onClickOfCard={() => {
                      history.push(
                        getAdvancedPathWithParam({
                          path: `${MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERINAPPROVAL}`,
                          pathParam: [ti.employeeId, ti.id],
                        })
                      );
                    }}
                  />
                </div>
              );
            })}
          </InfiniteScroll>
        </LoaderWrapper>
      </div>
    </ManageTransactionLayout>
  );
};

export default PendingRolloverin;
